const showForm1262Form = require("../../run/form1262/showForm1262Form");
const hideForm1262ReturningUser = require("../../run/form1262/hideForm1262ReturningUser");

/**
 * @returns {void}
 */
module.exports = function whenForm1262ReturningUserNotYouButtonClicked() {
    showForm1262Form();
    hideForm1262ReturningUser();
};
